import { useEffect, useRef, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";
import trash from '../../assets/images/trash.svg';
import add_img from '../../assets/images/add_img.png';
import default150 from '../../assets/images/default150.png';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import CropperModal from "../CropperModal";
import loadingimg from '../../assets/images/loading-buffering.gif';
import { getSizedImageUrl } from "../../utils/getSizedImageUrl";

const MySwal = withReactContent(Swal);


type UpdateImagesProps = {
  onSaveSuccess: () => void;              // ✅ callback to scroll
  
};

const UpdateImages: React.FC<UpdateImagesProps> = ({ onSaveSuccess }) => {
  const { loading, activeSection,setActiveSection, uploadUserImage, deleteImage,setmainPhoto,setMainProfile, setMainImage } = useProfileUpdateStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const mainfileInputRef =useRef<HTMLInputElement>(null);
  // State for selected file & preview
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [mainselectedFile, setMainSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [mainpreviewUrl, setMainPreviewUrl] = useState<string | null>(null);
  const [uploadTarget, setUploadTarget] = useState<"profile" | "background" | null>(null);
  const [showCropper, setShowCropper] = useState(false);
   const [resolvedImageMap, setResolvedImageMap] = useState<Record<string, string>>({});
   const [resolvedImageMain, setResolvedImageMain] = useState<string>('');
  const [cropConfig, setCropConfig] = useState<{ width: number; height: number } | undefined>(undefined);
const WSurl = import.meta.env.VITE_APP_WS_URL;



useEffect(() => {
  const loadProfileImages = async () => {
    if (!user?.user_photos?.length) return;

    // Step 1: Show loading images for all
    user.user_photos.map(() => loadingimg);
    setResolvedImageMap(
      Object.fromEntries(user.user_photos.map((photo:any) => [photo.id, loadingimg]))
    );

    // Step 2: Delay to ensure spinner is seen
    await new Promise(resolve => setTimeout(resolve, 500));

    // Step 3: Load actual resized URLs
    const entries = await Promise.all(
      user.user_photos.map(async (photo: any) => {
        const url = photo.picture;
        const sizedUrl = url
          ? await getSizedImageUrl(url, '150x150')
          : default150;
        return [photo.id, sizedUrl || default150];
      })
    );

    setResolvedImageMap(Object.fromEntries(entries));

    // Step 4: Handle main photo
    const mainPhoto =
      user.user_photos.find((photo: any) => photo.main_photo) ||
      user.user_photos[0];
    const sizedMainPhoto = await getSizedImageUrl(
      mainPhoto?.picture,
      '150x150'
    );
    setResolvedImageMain(sizedMainPhoto || user.pic || default150);
  };

  loadProfileImages();
}, [user]);
useEffect(() => {
  if (!user?.id) return;

  const socket = new WebSocket(`${WSurl}${user.id}?type=thumbnail`);

  socket.onmessage = (event) => {
    const data = JSON.parse(event.data);
    if (data.type === 'thumbnail_update' && data.status === 'done') {
      console.log('Thumbnail updated:', data);
      getUserDetails(user.id);
    }
  };

  socket.onerror = (error) => {
    console.error('WebSocket error (thumbnail):', error);
  };

  return () => {
    socket.close();
  };
}, []);
  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
    }
  }, [userId, user,setmainPhoto]);

  useEffect(() => {

      getUserDetails(userId);
 
  }, [setmainPhoto,setMainImage]);




  const handleCroppedImage = async (cropped: File) => {
  
  if (uploadTarget === "profile") {
    setMainPreviewUrl(URL.createObjectURL(cropped));
    setMainSelectedFile(cropped);
   
  } else if (uploadTarget === "background") {
    setPreviewUrl(URL.createObjectURL(cropped));
    setSelectedFile(cropped);// or update index
  }
  setShowCropper(false);
};

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    target: "profile" | "background"
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const cropSize = target === "profile"
      ? { width: 389, height: 438 }
      : { width: 795, height: 320 };

  
    if( target === "profile"){
      
      setMainPreviewUrl(URL.createObjectURL(file));
    }else{
      setPreviewUrl(URL.createObjectURL(file));
        setSelectedFile(file);
     }
    setUploadTarget(target); // ✅ Set target
    setCropConfig(cropSize);
    setShowCropper(true);
  };


    const handleUpload = async () => {
    if (!selectedFile && !mainselectedFile) return;
    if(selectedFile){
      await uploadUserImage(userId, selectedFile);
    }
     if(mainselectedFile){
     await setMainProfile(userId, mainselectedFile);
    }
     // or however you store main photo
   
    getUserDetails(userId); // Refresh user details
    setSelectedFile(null);
    setPreviewUrl(null);
    setMainPreviewUrl(null);
   // setActiveSection(null); // Hide section
    onSaveSuccess(); // Callback
  };


  // Confirm photo deletion
  const confirmDeletePhoto = (photoId: any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Delete Photo?</h3>
          <p>Do you really want to delete this photo?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={async () => { 
             await deleteImage(photoId); 
              getUserDetails(userId);
              MySwal.close();
            }}>
              Yes, Delete
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };

  // Find the main photo
 
  if (activeSection !== "photos") return null;
  return (
    <div className="card border mb-3">
      <div className="border-bottom pb-4 mb-4 d-flex w-100 align-items-center gap-3">
        <h4 className="mb-0">Photos</h4>
        <button className="btn_close_cross_btn ms-auto" onClick={() => setActiveSection(null)}>
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
  
      <div className="edit_photos_gallary_box text-center border-bottom pb-4 mb-4 px-4">
        <h5 className="font16 font600 mb-3">Your main photo</h5>
        <div className="edit_main_profile_box_img">
          <img src={mainpreviewUrl || resolvedImageMain  || default150} alt="Main Profile" className="img-fluid" />
          
        </div>
        <span className="info-text">(Size 389*438)</span>
         <input
          type="file"
          accept="image/*"
          ref={mainfileInputRef}
          onChange={(e) => handleFileChange(e, "profile")}
          className="d-none"
        />
        
         <button className="btn btn-outline-secondary d-inline-flex align-items-center py-2 mt-3"
           onClick={() => mainfileInputRef.current?.click()}>
          
          <svg 
            xmlns="http://www.w3.org/2000/svg"
            className="svgupload text-red-600 "
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M16 8l-4-4m0 0L8 8m4-4v12"
            />
          </svg> Upload photo
        </button>
        {/* {mainPhoto?.picture || user.pic ?
        <button className="btn btn-outline-secondary d-inline-flex align-items-center py-2 mt-3"
          onClick={() => confirmDeletePhoto(mainPhoto?.id)}>
          <img src={trash} alt="" className="img-fluid me-2 edit-icon" />
          Delete photo
        </button>
        :''} */}
      </div>
  
      <div className="border-bottom pb-4 mb-4 px-4">
        <h4 className="mb-3">Your photo gallery</h4>
        <div className="row g-3">
         {user?.user_photos?.map((photo: any) => {
           

            if (photo.main_photo != 0) return null;

            return (
              <div className="col-6" key={photo.id}>
                <div className="profile_edit_gallary_item position-relative">
                  <img src={resolvedImageMap[photo.id]} alt="" className="img-fluid" />
                  <button className="btn delete_btn_sm" onClick={() => confirmDeletePhoto(photo.id)}>
                    <img src={trash} alt="" />
                  </button>
                  <div className="profile_edit_gallary_cnt">
                    <i className="fa-regular fa-star text-primary"></i>
                    <span role="button" onClick={() => setMainImage(photo.id)}>Set as main photo</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
  
      <div className="profile_edit_gallary_add_item_box px-4 text-center mb-4">
        <img src={add_img} alt="Add" className="add_glry_img_item mb-2" />
        <p>Pick a few solo photos with your face clearly visible and don't forget to smile!</p>
  
        {previewUrl && (
          <div className="mt-3">
            <h6>Selected Image Preview</h6>
            <img src={previewUrl} alt="Preview" className="img-fluid rounded mb-3" style={{ maxWidth: 150 }} />
          </div>
        )}
        {/* <span className="info-text">(Size 792*320)</span> */}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={(e) => handleFileChange(e, "background")}
          className="d-none"
        />
        <button
          className="btn btn-outline-secondary py-2"
          onClick={() => fileInputRef.current?.click()}
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg"
            className="svgupload text-red-600 "
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M16 8l-4-4m0 0L8 8m4-4v12"
            />
          </svg> Upload photo
        </button>
      </div>
  
      <div className="px-4 pb-4">
      <button
        className="btn btn-outline-primary w-100"
        onClick={handleUpload}
        disabled={!selectedFile && !mainselectedFile || loading}
      >
        {loading ? "Uploading..." : "Save Changes"}
      </button>
      </div>
    {showCropper && cropConfig && uploadTarget && (
          <CropperModal
            show={showCropper}
            imageUrl={uploadTarget =='background'? previewUrl : mainpreviewUrl}
            aspectRatio={0}
           //outputSize={cropConfig}
            onCancel={() => {setShowCropper(false); 
              setPreviewUrl(null); 
              setMainPreviewUrl(null); 
              previewUrl ? setSelectedFile(null) : '';
              if (previewUrl && fileInputRef.current) {
                fileInputRef.current.value = "";
              }
               if (mainpreviewUrl && mainfileInputRef.current) {
                mainfileInputRef.current.value = "";
              }
            }}
            onCrop={handleCroppedImage}
          />
        )}
    </div>
  );
  
};

export default UpdateImages;
